import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">

<path d="M4646 7238 c-144 -18 -267 -116 -329 -261 l-22 -52 0 -790 0 -790 34
-72 c33 -71 35 -73 71 -73 35 0 181 19 300 39 245 41 521 126 705 217 130 64
244 138 228 147 -4 2 -39 15 -78 27 -315 102 -591 281 -711 461 -61 93 -86
165 -92 271 -5 104 17 188 75 286 46 78 177 205 280 273 115 75 304 164 469
219 80 27 148 50 150 53 12 11 -158 40 -286 48 -162 11 -703 8 -794 -3z"/>
<path d="M5950 7003 c-235 -54 -428 -121 -590 -204 -103 -53 -207 -124 -193
-132 4 -2 40 -15 78 -27 401 -131 696 -356 781 -597 9 -26 19 -84 21 -128 10
-159 -45 -285 -186 -426 -176 -176 -433 -306 -805 -408 -82 -23 -157 -41 -167
-41 -10 0 -20 -3 -22 -7 -8 -12 629 -5 713 8 158 24 341 101 475 201 441 329
579 905 333 1393 -52 105 -117 194 -198 276 -117 118 -121 120 -240 92z"/>
<path d="M4992 6453 c-16 -40 -7 -137 18 -188 51 -103 216 -239 385 -319 171
-81 391 -154 409 -136 6 6 11 41 11 78 0 51 -6 79 -25 116 -84 166 -338 330
-678 436 -113 35 -111 35 -120 13z"/>
<path d="M3590 4416 c0 -226 4 -365 11 -383 30 -82 125 -126 223 -104 78 18
78 17 63 92 -10 46 -18 63 -28 61 -36 -9 -81 -5 -90 8 -5 9 -9 163 -9 348 l0
332 -85 0 -85 0 0 -354z"/>
<path d="M4900 4355 l0 -415 85 0 85 0 0 43 c0 36 7 50 43 92 l43 48 70 -91
69 -91 108 -1 108 0 -120 157 -120 158 27 30 c16 16 61 67 101 113 l73 82
-103 -1 -104 -1 -90 -103 c-49 -57 -93 -104 -97 -104 -5 -1 -8 112 -8 249 l0
250 -85 0 -85 0 0 -415z"/>
<path d="M4014 4730 c-31 -12 -54 -49 -54 -88 0 -47 16 -71 57 -88 66 -28 133
14 133 84 0 44 -14 68 -50 87 -32 17 -54 18 -86 5z"/>
<path d="M3087 4667 c-60 -14 -128 -55 -158 -97 -27 -36 -40 -115 -28 -171 20
-92 83 -134 259 -174 84 -18 120 -31 133 -46 24 -30 21 -46 -12 -80 -24 -24
-38 -29 -76 -29 -62 0 -108 23 -131 66 -23 42 -25 42 -171 9 -50 -12 -5 -112
74 -164 64 -43 112 -55 219 -55 83 0 97 3 158 33 52 26 74 43 96 77 53 83 48
181 -12 250 -42 48 -68 60 -210 93 -80 19 -126 35 -135 47 -37 51 8 104 89
104 43 0 55 -5 82 -32 18 -18 35 -39 38 -47 4 -13 15 -13 79 -2 41 7 79 16 86
20 20 10 -29 103 -73 139 -71 59 -198 83 -307 59z"/>
<path d="M5570 4299 l0 -361 203 4 c245 5 286 16 378 107 71 70 99 140 99 244
0 123 -31 199 -111 271 -84 76 -163 96 -391 96 l-178 0 0 -361z m396 183 c86
-44 127 -135 104 -233 -25 -102 -95 -150 -232 -157 l-88 -4 0 212 0 213 88 -5
c61 -4 100 -11 128 -26z"/>
<path d="M6999 4648 c-1 -7 -2 -47 -3 -88 l-1 -75 -47 -3 -48 -3 0 -70 0 -69
50 0 50 0 -1 -135 c0 -120 2 -141 21 -181 33 -67 94 -99 185 -98 75 1 145 23
145 47 0 7 -7 36 -15 64 l-15 51 -58 -4 c-31 -3 -64 -1 -72 5 -17 12 -28 108
-22 193 l4 58 73 0 c82 0 82 0 81 85 l-1 50 -77 3 -78 3 -1 37 c0 20 -1 60 -2
87 l-2 50 -82 3 c-62 2 -83 0 -84 -10z"/>
<path d="M4479 4490 c-87 -15 -172 -77 -215 -160 -27 -50 -26 -190 1 -245 50
-100 145 -158 265 -159 90 -1 158 25 213 82 36 37 73 109 62 120 -5 6 -150 43
-150 39 0 -20 -39 -66 -68 -80 -53 -27 -107 -16 -147 29 -26 30 -30 42 -30 95
0 56 3 64 34 95 58 58 159 46 191 -22 11 -24 21 -33 33 -30 9 2 43 10 75 17
32 7 60 16 63 20 2 4 -5 28 -17 53 -50 107 -178 167 -310 146z"/>
<path d="M6517 4486 c-77 -22 -157 -97 -157 -147 0 -21 151 -50 158 -30 9 27
47 51 82 51 42 0 80 -33 80 -68 0 -21 -4 -22 -98 -22 -53 0 -112 -4 -131 -10
-54 -15 -99 -52 -116 -93 -69 -172 111 -302 301 -218 36 16 44 17 44 5 0 -11
18 -14 86 -14 l85 0 -3 203 c-3 200 -3 203 -30 249 -21 35 -41 53 -80 72 -66
31 -156 40 -221 22z m163 -349 c0 -26 -43 -71 -78 -82 -71 -21 -132 28 -98 80
15 23 22 25 96 25 77 0 80 -1 80 -23z"/>
<path d="M7640 4493 c-91 -16 -157 -58 -189 -120 -20 -40 -14 -48 47 -61 71
-15 102 -15 102 -2 0 6 9 19 20 30 44 44 140 11 140 -48 0 -21 -4 -22 -108
-22 -95 0 -114 -3 -158 -25 -120 -59 -128 -212 -16 -290 39 -27 51 -30 120
-30 62 0 85 5 115 23 45 26 47 26 47 7 0 -13 14 -15 83 -13 l82 3 0 200 c-1
223 -4 236 -69 293 -46 40 -150 67 -216 55z m116 -364 c-16 -80 -155 -108
-180 -36 -8 21 -6 31 9 47 15 17 30 20 98 20 l80 0 -7 -31z"/>
<path d="M3970 4210 l0 -270 85 0 85 0 0 270 0 270 -85 0 -85 0 0 -270z"/>
<path d="M3907 3762 c-10 -10 -17 -26 -17 -35 0 -9 -4 -17 -10 -17 -5 0 -10
-7 -10 -15 0 -8 5 -15 10 -15 6 0 10 -27 10 -60 0 -47 3 -60 15 -60 12 0 15
13 15 60 l0 60 35 0 35 0 0 -60 c0 -47 3 -60 15 -60 12 0 15 13 15 60 0 57 1
60 25 60 16 0 25 6 25 15 0 9 -10 15 -26 15 -33 0 -30 33 4 38 27 4 29 32 2
32 -23 0 -60 -33 -60 -55 0 -10 -11 -15 -35 -15 -42 0 -48 25 -9 40 14 6 22
14 19 20 -10 16 -40 12 -58 -8z"/>
<path d="M6168 3769 c-10 -5 -18 -21 -18 -34 0 -16 -6 -25 -15 -25 -8 0 -15
-7 -15 -15 0 -8 7 -15 15 -15 12 0 15 -13 15 -60 0 -47 3 -60 15 -60 12 0 15
13 15 60 l0 60 35 0 35 0 0 -60 c0 -47 3 -60 15 -60 12 0 15 13 15 60 l0 60
35 0 35 0 0 -60 c0 -47 3 -60 15 -60 12 0 15 15 15 75 l0 75 -51 0 c-43 0 -50
3 -47 18 2 9 14 18 26 20 26 4 25 25 -2 30 -22 5 -56 -25 -56 -50 0 -14 -8
-18 -35 -18 -28 0 -35 4 -35 20 0 13 7 20 20 20 11 0 20 7 20 15 0 17 -27 19
-52 4z"/>
<path d="M4510 3728 c0 -33 -3 -39 -12 -30 -14 14 -53 16 -77 2 -28 -14 -44
-61 -32 -93 12 -30 55 -62 71 -52 6 4 27 7 46 7 l34 0 0 104 c0 86 -3 104 -15
104 -11 0 -15 -11 -15 -42z m-7 -69 c14 -23 1 -67 -23 -74 -23 -7 -55 8 -64
30 -3 8 -1 27 4 41 8 21 15 25 41 22 18 -2 36 -10 42 -19z"/>
<path d="M4780 3666 l0 -104 38 -1 c20 -1 48 -2 62 -2 32 -1 60 34 60 76 0 48
-41 79 -92 71 -38 -6 -38 -6 -38 29 0 24 -5 35 -15 35 -12 0 -15 -18 -15 -104z
m118 2 c27 -27 3 -88 -34 -88 -26 0 -56 39 -48 63 4 12 12 25 18 29 17 12 51
9 64 -4z"/>
<path d="M4980 3665 c0 -87 3 -105 15 -105 12 0 15 18 15 105 0 87 -3 105 -15
105 -12 0 -15 -18 -15 -105z"/>
<path d="M5800 3735 c0 -35 0 -35 -38 -29 -51 8 -92 -23 -92 -71 0 -47 27 -76
70 -75 19 0 47 1 63 1 l27 0 0 104 c0 87 -3 105 -15 105 -10 0 -15 -11 -15
-35z m-24 -63 c6 -4 13 -17 17 -30 6 -25 -22 -62 -47 -62 -37 0 -61 61 -34 88
13 13 47 16 64 4z"/>
<path d="M6350 3756 c0 -21 21 -31 30 -15 5 7 6 17 4 21 -9 14 -34 9 -34 -6z"/>
<path d="M6604 3759 c-8 -14 18 -31 30 -19 9 9 0 30 -14 30 -5 0 -12 -5 -16
-11z"/>
<path d="M3706 3674 c-52 -119 -50 -114 -32 -114 9 0 21 11 26 26 9 23 14 25
57 22 39 -2 50 -7 58 -25 5 -13 18 -23 27 -23 20 0 20 2 -36 123 -19 42 -42
77 -49 77 -8 0 -30 -39 -51 -86z m69 6 c21 -41 19 -50 -15 -50 -20 0 -30 5
-30 15 0 14 20 65 26 65 2 0 10 -13 19 -30z"/>
<path d="M5950 3660 l0 -100 75 0 c60 0 75 3 75 15 0 12 -13 15 -61 15 -60 0
-60 0 -57 27 3 24 7 26 52 27 30 1 51 6 53 14 3 9 -11 12 -51 12 -56 0 -56 0
-56 30 l0 30 60 0 c47 0 60 3 60 15 0 12 -15 15 -75 15 l-75 0 0 -100z"/>
<path d="M7060 3731 c0 -10 -9 -21 -20 -24 -11 -3 -20 -10 -20 -16 0 -6 9 -11
20 -11 18 0 20 -7 20 -55 0 -44 4 -56 20 -65 25 -13 60 -4 60 16 0 8 -9 13
-22 11 -21 -2 -23 3 -26 46 -3 45 -2 47 23 47 32 0 29 23 -3 28 -14 2 -22 11
-22 23 0 10 -7 19 -15 19 -8 0 -15 -8 -15 -19z"/>
<path d="M4105 3685 c-27 -26 -31 -54 -14 -88 16 -30 28 -37 69 -37 19 0 40 4
46 8 16 11 34 48 34 72 0 32 -44 70 -80 70 -19 0 -40 -9 -55 -25z m99 -37 c8
-22 6 -32 -9 -48 -22 -24 -42 -25 -67 -3 -38 34 -15 86 37 81 22 -2 32 -10 39
-30z"/>
<path d="M4277 3703 c-2 -5 -5 -38 -6 -75 -1 -54 2 -68 14 -68 8 0 15 8 15 18
0 46 21 92 45 98 14 3 25 12 25 20 0 18 -20 18 -48 -2 -20 -14 -22 -14 -22 0
0 16 -16 22 -23 9z"/>
<path d="M4602 3689 c-46 -42 -18 -132 40 -130 13 0 38 1 56 1 l32 1 0 72 0
72 -53 2 c-42 2 -58 -2 -75 -18z m86 -21 c7 -7 12 -25 12 -40 0 -34 -41 -59
-68 -41 -21 12 -28 59 -11 79 14 17 51 18 67 2z"/>
<path d="M5073 3695 c-46 -32 -35 -119 16 -132 38 -10 61 -6 82 13 15 13 16
19 7 25 -7 5 -20 2 -29 -7 -21 -19 -43 -18 -62 4 -23 25 -13 32 50 32 45 0 53
3 53 18 0 26 -42 62 -71 62 -13 0 -34 -7 -46 -15z m81 -30 c4 -12 -3 -15 -34
-15 -38 0 -49 8 -33 23 12 13 61 7 67 -8z"/>
<path d="M5314 3685 c-25 -25 -31 -63 -14 -95 13 -24 67 -42 89 -30 10 5 28 6
40 3 21 -5 22 -4 19 67 l-3 74 -53 3 c-45 2 -57 -1 -78 -22z m98 -30 c9 -19 8
-29 -6 -50 -18 -27 -36 -31 -67 -15 -22 12 -26 59 -7 78 22 22 67 14 80 -13z"/>
<path d="M5499 3700 c-1 -5 -1 -102 0 -128 1 -8 7 -12 14 -10 7 3 14 28 17 59
5 50 7 54 32 57 34 4 51 -26 46 -79 -3 -33 -1 -39 15 -39 17 0 19 6 15 61 -5
75 -20 89 -89 86 -27 -1 -49 -4 -50 -7z"/>
<path d="M6446 3689 c-45 -35 -33 -105 22 -128 34 -14 76 -2 92 29 13 25 -5
28 -31 4 -26 -23 -67 -11 -75 23 -13 50 38 82 76 48 29 -26 46 -8 19 21 -28
30 -68 31 -103 3z"/>
<path d="M6610 3636 c0 -62 3 -76 15 -76 13 0 15 12 13 72 -2 46 -7 73 -15 76
-10 3 -13 -16 -13 -72z"/>
<path d="M6702 3690 c-28 -26 -30 -90 -4 -112 36 -32 103 -27 116 8 7 17 1 17
-40 2 -26 -9 -36 -9 -48 1 -25 21 -19 40 12 39 74 -1 82 1 82 26 0 51 -77 74
-118 36z m86 -27 c2 -9 -9 -13 -37 -13 -39 0 -50 8 -34 24 11 11 66 2 71 -11z"/>
<path d="M6860 3635 c0 -60 3 -75 15 -75 11 0 15 11 15 43 0 54 18 80 51 75
22 -3 24 -8 27 -60 2 -43 7 -58 17 -58 24 0 21 112 -3 133 -21 19 -45 21 -73
7 -13 -7 -19 -7 -19 0 0 5 -7 10 -15 10 -12 0 -15 -15 -15 -75z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
